import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const SUBMIT_APP_FOR_APPROVAL = gql`
  mutation submitMyAppForApproval($version: String!, $identifier: String!) {
    app {
      appVersionMutation {
        submitNewVersion(
          inputType: { version: $version, identifier: $identifier }
        )
      }
    }
  }
`;

const submitAppForApprovalRequest = ({
  version,
  identifier,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={SUBMIT_APP_FOR_APPROVAL}>
    {(submitMyAppForApproval, { loading, error, data }) => {
      const variables = {
        version,
        identifier,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.app.appVersionMutation.submitNewVersion);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={submitMyAppForApproval}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

submitAppForApprovalRequest.propTypes = {
  identifier: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
};

export default submitAppForApprovalRequest;
